/**
 * API 响应适配器
 * 用于适配后端统一响应格式 ApiResult
 */

/**
 * 解析统一响应格式
 * @param {Response} response - fetch Response 对象
 * @returns {Promise<any>} - 解析后的数据
 */
export async function parseApiResponse(response) {
  const result = await response.json();
  
  // 如果是新的统一格式 { code, message, data, timestamp }
  if (result && typeof result.code === 'number') {
    if (result.code === 200) {
      return result.data;
    } else {
      throw new Error(result.message || '请求失败');
    }
  }
  
  // 兼容旧格式（直接返回数据）
  return result;
}

/**
 * 包装 fetch 请求，自动处理统一响应格式
 * @param {string} url - 请求地址
 * @param {Object} options - fetch 选项
 * @returns {Promise<any>} - 解析后的数据
 */
export async function apiFetch(url, options = {}) {
  // 对 userId 进行编码，处理非 ASCII 字符（如中文）
  const userId = encodeURIComponent(localStorage.getItem('app_user_id') || 'default_user');
  const token = localStorage.getItem('app_token') || '';
  const headers = {
    'X-User-ID': userId,
    ...options.headers,
  };
  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  const response = await fetch(url, {
    ...options,
    headers,
  });
  
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || `HTTP ${response.status}`);
  }
  
  return parseApiResponse(response);
}

/**
 * POST 请求快捷方法
 */
export async function apiPost(url, data) {
  return apiFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}

/**
 * GET 请求快捷方法
 */
export async function apiGet(url) {
  return apiFetch(url, {
    method: 'GET',
  });
}
